import { Box } from "@mui/material";
import { useUserContext } from "../../context";
import { useApi } from "../../services";
import { useEffect, useState } from "react";
import Logo from "../../assets/logoSemFundo.png";

export const Estatisticas: React.FC = () => {

  return <Box sx={{
    flex: 1,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  }}>

    {/* Logo */}
    <img
      src={Logo}
      alt={"logo"}
      style={{
        cursor: "pointer",
        objectFit: "contain",
        height: `40vh`,
        width: `40vh`,
      }}
    />

  </Box>;
};